import { X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ConfirmRemoveVendorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  vendorName: string;
}

export default function ConfirmRemoveVendorModal({
  isOpen,
  onClose,
  onConfirm,
  vendorName,
}: ConfirmRemoveVendorModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-xl shadow-2xl max-w-sm w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#063F6B] to-[#124C77] p-5">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-white">Remove Vendor</h2>
            <button
              onClick={onClose}
              className="text-white/70 hover:text-white transition-colors p-2 rounded-lg hover:bg-white/10 min-w-[40px] min-h-[40px] flex items-center justify-center"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="p-5">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center">
              <Trash2 className="w-5 h-5 text-destructive" />
            </div>
            <div>
              <p className="text-sm text-foreground font-medium">{vendorName}</p>
              <p className="text-sm text-muted-foreground">
                will be removed from this workspace.
              </p>
            </div>
          </div>

          <p className="text-sm text-muted-foreground mb-5">
            This will remove the vendor and any associated evaluations from the workspace. This action cannot be undone.
          </p>

          <div className="flex gap-3">
            <Button variant="outline" className="flex-1" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              className="flex-1"
              onClick={onConfirm}
            >
              Remove
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
